import React, { Component, ReactElement } from 'react';

import { NotificationData } from '@philips-emr/tws-components-api';
import { ClickEvent } from '@philips-emr/tws-core/lib/component/types';
import { isDefined, isFunction } from '@philips-emr/tws-utils';

export interface NotificationItemProps {
  data: NotificationData[];
  onItemClick: (item: NotificationData) => void;
}

export interface NotificationItemCellProps {
  onClick?: (event: ClickEvent) => void;
  item: NotificationData;
  index: number;
}

class NotificationItemRow extends Component<NotificationItemProps> {

  render(): ReactElement[] | null {
    const { data, onItemClick } = this.props;

    if (!Array.isArray(data)) {
      return null;
    }

    const validData = data.filter((item) => isDefined(item.title));

    return validData.map((item, index) => {
      return (
        <NotificationItemCell
          onClick={() => onItemClick(item)}
          item={item}
          index={index}
          key={index}
        />
      );
    });
  }
}

function NotificationItemCell(props: NotificationItemCellProps): ReactElement {
  const { onClick, item, index } = props;
  const { description, id, title } = item;
  const key = id || index;

  const onNotificationClick = (): void => {
    if (isFunction(onClick)) {
      onClick(new ClickEvent());
    }
  };

  return (
    <div className="c-notification__border" key={key} onClick={onNotificationClick}>
      <div className="c-notifications__item" >
        <div className="c-notification__name">{title}</div>
        <div className="c-notification__status">
          {description}
        </div>
      </div>
    </div>
  );
}

export default NotificationItemRow;
